import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';

import {AppService} from '@api';

import {MensajeService} from '@mensaje/Mensaje.Service';
import {InformacionModel} from '@mensaje/Modelo/Informacion.model';
import {AlertaEnum} from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import {SistemaService} from '@servicios/Sistema.Service';
import {RespuestaEstatusEnum} from '@enumeraciones/Enumeraciones.enum';

@Component(
    {
        selector: 'recuperarPassword',
        templateUrl: './RecuperarPassword.template.html',
        styleUrls: ['./RecuperarPassword.scss'],
    })

export class RecuperarPasswordComponent {
    public errorActivo: boolean = false;
    public modalabierto: boolean = false;
    public cuenta: string = "";
    public animacion: string = "";
    correo: string = '';

    constructor(private appService: AppService, private router: Router, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService) {
    }

    ngOnInit() {
    }

    Abrir(cuenta: string) {
        this.animacion = "fadeInUp";
        this.cuenta = cuenta;
        this.errorActivo = false;
        this.modalabierto = true;
    }

    EnviarPasssword() {
        this.errorActivo = true;

        if (!this.validarDatos()) {
            this.mensajeService.Alerta(AlertaEnum.Warning, this.translate.instant("ErrorDatosIncompletos"));
            return;
        }
        else {
            this.appService.Post("auth/recuperarpassword", {Cuenta: this.cuenta}).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    let mensaje = new InformacionModel({Mensaje: res.message, OrigenHTML: true});
                    this.mensajeService.Mensaje(mensaje);
                    this.Cerrar();
                }
            })

        }
    }

    validarDatos() {
        if (!this.cuenta) {
            return false;
        }

        return true;
    }


    Cerrar() {
        this.animacion = "fadeOutUp";

        setTimeout(() => {
            this.modalabierto = false;
        }, 310);
    }
}
